export default "__VITE_ASSET__DiRzHCKY__"